/**
 * Collect image attribution fields from CMS content entries for footer credits.
 * Expects image{One|Two|Three|Four}Attribution and optional …AttributionURL.
 * Dedupes identical text+url pairs. Skips inactive sections when `active` is set.
 */

const SLOTS = ["One", "Two", "Three", "Four"];

function isActiveEntry(item) {
  if (!item || typeof item !== "object") return false;
  if (!Object.hasOwn(item, "active")) return true;
  const a = item.active;
  if (a === false || a === "false") return false;
  if (typeof a === "string" && a.replace(/\s/g, "") === "") return false;
  return true;
}

function clean(value) {
  if (value == null) return "";
  const s = String(value).trim();
  return s;
}

/**
 * @param {Record<string, object>|null|undefined} content - contentData.content map
 * @returns {{ label: string, url: string|null }[]}
 */
export function gatherImageAttributions(content) {
  if (!content || typeof content !== "object") return [];

  const seen = new Set();
  const list = [];

  for (const item of Object.values(content)) {
    if (!isActiveEntry(item)) continue;

    for (const slot of SLOTS) {
      const label = clean(item[`image${slot}Attribution`]);
      const url = clean(item[`image${slot}AttributionURL`]);
      if (!label && !url) continue;

      const key = `${label.toLowerCase()}|${url.toLowerCase()}`;
      if (seen.has(key)) continue;
      seen.add(key);

      list.push({
        label: label || "Image credit",
        url: url || null,
      });
    }
  }

  return list;
}
